import { render, staticRenderFns } from "./DangerManagement.vue?vue&type=template&id=6b10e534&scoped=true&"
import script from "./DangerManagement.vue?vue&type=script&lang=js&"
export * from "./DangerManagement.vue?vue&type=script&lang=js&"
import style0 from "./DangerManagement.vue?vue&type=style&index=0&id=6b10e534&lang=scss&scoped=true&"
import style1 from "./DangerManagement.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b10e534",
  null
  
)

export default component.exports